import type {
  ApplicationStatus,
  EmployerApplicantLibraryStage,
  EmployerApplicationStatusUpdateInput,
} from "@tabbio/types";
import { JOB_STATUS_COLORS } from "./jobs-format";

export const EMPLOYER_APPLICANT_FILTER_STATUSES: ApplicationStatus[] = [
  "applied",
  "reviewed",
  "shortlisted",
  "interview",
  "offered",
  "rejected",
  "withdrawn",
];

export function getEmployerApplicantStatusColor(status: ApplicationStatus) {
  return JOB_STATUS_COLORS[status] ?? "#6B7280";
}

export function getEmployerApplicantStagePalette(
  stage: EmployerApplicantLibraryStage,
) {
  if (stage === "screening") {
    return {
      bg: "rgba(94, 41, 255, 0.14)",
      text: "#5E29FF",
    };
  }

  if (stage === "interview") {
    return {
      bg: "rgba(16, 185, 129, 0.16)",
      text: "#059669",
    };
  }

  if (stage === "offer") {
    return {
      bg: "rgba(249, 115, 22, 0.16)",
      text: "#EA580C",
    };
  }

  return {
    bg: "rgba(107, 114, 128, 0.14)",
    text: "#6B7280",
  };
}

export function getEmployerApplicantStatusPalette(status: ApplicationStatus) {
  const color = getEmployerApplicantStatusColor(status);
  return {
    bg:
      status === "rejected"
        ? "rgba(255, 59, 48, 0.12)"
        : status === "withdrawn"
          ? "rgba(255, 149, 0, 0.12)"
          : status === "interview"
            ? "rgba(52, 199, 89, 0.14)"
            : status === "offered"
              ? "rgba(48, 176, 199, 0.14)"
              : status === "shortlisted"
                ? "rgba(94, 92, 230, 0.14)"
                : status === "reviewed"
                  ? "rgba(10, 132, 255, 0.14)"
                  : "rgba(142, 142, 147, 0.14)",
    text: color,
  };
}

export function getEmployerApplicantNextStatuses(
  status: ApplicationStatus,
): EmployerApplicationStatusUpdateInput["status"][] {
  if (status === "applied") {
    return ["reviewed", "rejected"];
  }

  if (status === "reviewed") {
    return ["shortlisted", "rejected"];
  }

  if (status === "shortlisted") {
    return ["interview", "rejected"];
  }

  if (status === "interview") {
    return ["offered", "rejected"];
  }

  return [];
}

export function getEmployerApplicantInitials(name?: string | null) {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean).slice(0, 2);

  if (!parts.length) {
    return "?";
  }

  return parts.map((part) => part.charAt(0).toUpperCase()).join("");
}
